module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('form', {
    staticClass: "row px-0 mx-0"
  }, [_c('div', {
    staticClass: "col-6 mb-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "mb-2 d-block",
    attrs: {
      "for": "firstName"
    }
  }, [_vm._v("Nombre")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.perfil.nombre
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 mb-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "mb-2 d-block",
    attrs: {
      "for": "lastName"
    }
  }, [_vm._v("Apellido")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.perfil.apellido
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 mb-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "mb-2 d-block",
    attrs: {
      "for": "exampleInputEmail1"
    }
  }, [_vm._v("Teléfono")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.perfil.telefono
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 mb-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "mb-2 d-block",
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("Url Avatar")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.perfil.avatar
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 mb-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "mb-2 d-block",
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("Store")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.perfil.store === 1 ? 'Sendi' : 'Envios'
    }
  })])])]), _vm._v(" "), _c('div', {}, [_c('div', [_c('h5', {
    staticClass: "bold mb-2"
  }, [_vm._v("Dirección de facturación")]), _vm._v(" "), _c('form', {
    staticClass: "row px-0 mx-0"
  }, [_c('div', {
    staticClass: "col-6 mb-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "mb-2 d-block",
    attrs: {
      "for": "firstName"
    }
  }, [_vm._v("Dirección")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.direction.direction
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 mb-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "mb-2 d-block",
    attrs: {
      "for": "lastName"
    }
  }, [_vm._v("Piso")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.direction.piso
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 mb-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "mb-2 d-block",
    attrs: {
      "for": "exampleInputEmail1"
    }
  }, [_vm._v("Referencia")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.direction.referencia
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 mb-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "mb-2 d-block",
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("Departamento")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.direction.departamento
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 mb-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "mb-2 d-block",
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("Provincia")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.direction.provincia
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 mb-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "mb-2 d-block",
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("Distrito")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.direction.distrito
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "pt-0 d-flex justify-content-between align-items-center"
  }, [_vm._m(0), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.getDeleteUser.apply(null, arguments)
      }
    }
  }, [_vm._v("\n      Eliminar usuario\n    ")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h5', {
    staticClass: "bold mb-2"
  }, [_vm._v("Delete Your Account")]), _vm._v(" "), _c('p', {
    staticClass: "m-0 text-muted"
  }, [_vm._v("\n        Lorem ipsum dolor sit amet, consectetur adipiscing elit "), _c('br'), _vm._v("\n        ut aliquam, purus sit amet luctus venenatis, lectus "), _c('br'), _vm._v("\n        magna fringilla urna, porttitor\n      ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dda9e848"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/component-user/PerfilComponent.vue
// module id = 1918
// module chunks = 1